let CustomEvent:any = window.CustomEvent;

function CustomEventFix(event: any, params: any) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
}

if (typeof window.CustomEvent !== "function") {
    CustomEventFix.prototype = window.Event.prototype;
    CustomEvent = CustomEventFix;
}

export function emitCustomEvent(type: string, el: any, data: any){
    if(el) {
        el.dispatchEvent(new CustomEvent(type, {
            bubbles: true,
            cancelable: false,
            detail: data
        }));
    }
}